import React from 'react'
import classnames from 'classnames'

const HeaderTitle: React.FC<{ className?: string }> = ({
  className,
  children,
}) => {
  return (
    <h1
      className={classnames(
        className,
        'flex-1 text-lg font-medium md:text-3xl'
      )}
    >
      {children}
    </h1>
  )
}

export { HeaderTitle }
